import userApi from "api/user";
import { DatePicker } from "components/index";
import { Button, Col, Form, Modal, Row, Tooltip } from "antd";
import { useState } from "react";
import { DeleteOutlined } from '@ant-design/icons';
import { useTranslation } from "react-i18next";

export default function ModalDelete({ id, onSearch, openNotificationWithIcon }) {
  const [openModal, setOpenModal] = useState(false);
  const [form] = Form.useForm();

  const { t } = useTranslation()

  const onFinish = async () => {
    try {
      await userApi.deleteUser(id);
      onSearch();
      onCancel();
      openNotificationWithIcon("success", t('notification'), t('deleteEmployeeSuccess'));
    } catch (error) {
      openNotificationWithIcon("error", t('error'), error?.response?.data?.message || t('hasError'));
    }
  };

  const onCancel = () => {
    setOpenModal(false);
    form.resetFields();
  };

  return (
    <>
      <Tooltip title={t('deleteEmployee')}>
        <Button danger onClick={() => setOpenModal(true)}>
          <DeleteOutlined />
        </Button>
      </Tooltip>

      <Modal
        open={openModal}
        title={t('deleteEmployee')}
        centered
        footer={null}
        onCancel={onCancel}
        width={400}
        destroyOnClose
      >
        <Form form={form} onFinish={onFinish} layout="vertical">
          <h2 style={{ color: 'red' }}>{t('sureToDelete')}</h2>
          <Row gutter={16}>
            <Col span={8} offset={4}>
              <Form.Item>
                <Button danger style={{ width: "100%" }} htmlType="submit">
                  Ok
                </Button>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Button style={{ width: "100%" }} onClick={onCancel}>
                {t('cancel')}
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
}
